import React from 'react'
import { Divider, Box } from '@mui/material'

const sx = {
  root: {
    flex: 1,
    position: 'relative',
    [theme => theme.breakpoints.down('sm')]: {
    },
  },
  formBody: {
    display: 'flex',
    position: 'relative',
    flex: '1',
    [theme => theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  formBodyWithCenter: {
    display: 'flex',
    justifyContent: 'space-between',
    flex: '1',
    [theme => theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  leftSide: {
    marginRight: 124,
    width: 315,
    [theme => theme.breakpoints.down('sm')]: {
      margin: 0,
      width: 'initial',
    },
  },
  leftSideWithCenter: {
    marginRight: 0,
    width: 315,
    [theme => theme.breakpoints.down('sm')]: {
      margin: 0,
      width: 'initial',
    },
  },
  rightSide: {
    display: 'flex',
    flexDirection: 'column',
  },
  field: {
    height: 110,
    flex: 1,
    position: 'relative',
  },
  buttonBox: {
    width: theme => theme.spacing(17),
    [theme => theme.breakpoints.down('sm')]: {
      width: 'initial',
    },
  },
  avatar: {
    width: 152,
    height: 152,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    borderRadius: '50%',
    display: 'flex',
  },
  divider: {
    height: 400,
    width: 1,
    [theme => theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}

export const AccountFormLayout = ({
  leftSide,
  center,
  rightSide,
  buttonBox,
  rightSideFullSize = false,
  hideDividers = false,
  extraClasses = {},
}) => {

  return (
    <Box sx={sx.root}>
      <Box sx={(center || rightSideFullSize ? sx.formBodyWithCenter : sx.formBody)}
        className={`${extraClasses.extraWrapper}`}
      >
        <Box sx={center || rightSideFullSize ? sx.leftSideWithCenter : sx.leftSide}
          className={`${extraClasses.extraColumn}`}
        >
          {leftSide}
        </Box>
        {center && !hideDividers && <Divider classes={{ root: sx.divider }} />}
        {center && <Box sx={sx.leftSideWithCenter} className={`${extraClasses.extraColumn}`}>{center}</Box>}
        {rightSide && !hideDividers && <Divider classes={{ root: sx.divider }} />}
        {rightSide && (
          <Box sx={rightSideFullSize ? sx.leftSideWithCenter : sx.rightSide} className={`${extraClasses.extraColumn}`}
          >
            {rightSide}
          </Box>
        )}
      </Box>
      {buttonBox && (
        <div>
          <Box sx={sx.buttonBox}>{buttonBox}</Box>
        </div>
      )}
    </Box>
  )
}

export const AccountFormField = props => {
  const { children, style = {} } = props

  return (
    <Box sx={sx.field} style={style}>
      {children}
    </Box>
  )
}
